module.exports = __webpack_public_path__ + "static/media/melai.9a18868c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/melai.jpg
// module id = 740
// module chunks = 0